export default __webpack_public_path__ + "static/media/vkad_logo.671f7b9a.jpg";